export default [
  {
    path: '/honor',
    name: 'honor',
    component: () => import('@/views/menu/honor/honor.vue'),
    meta: {
      pageTitle: 'مدیریت دستاوردها',
      action: 'show',
      resource: 'HonorManager',
    },
  },
  {
    path: '/honor/details',
    name: 'addhonor',
    component: () => import('@/views/menu/honor/honordetails.vue'),
    meta: {
      pageTitle: 'ایجاد دستاورد',
      action: 'show',
      resource: 'HonorManager',
    },
  },
  {
    path: '/honor/details/:id',
    name: 'updatehonor',
    component: () => import('@/views/menu/honor/honordetails.vue'),
    meta: {
      pageTitle: 'ویرایش دستاورد',
      action: 'show',
      resource: 'HonorManager',
    },
  },
  {
    path: '/honorcategory',
    name: 'honorcategory',
    component: () => import('@/views/menu/honor/honorcategory.vue'),
    meta: {
      pageTitle: 'مدیریت دسته بندی های دستاورد',
      action: 'show',
      resource: 'HonorCategoryManager',
    },
  },
  {
    path: '/honorcategory/details',
    name: 'addhonorcategory',
    component: () => import('@/views/menu/honor/honorcategorydetails.vue'),
    meta: {
      pageTitle: 'ایجاد دسته بندی دستاورد',
      action: 'show',
      resource: 'HonorCategoryManager',
    },
  },
  {
    path: '/honorcategory/details/:id',
    name: 'updatehonorcategory',
    component: () => import('@/views/menu/honor/honorcategorydetails.vue'),
    meta: {
      pageTitle: 'ویرایش دسته بندی دستاورد',
      action: 'show',
      resource: 'HonorCategoryManager',
    },
  },
]
